// extracted by mini-css-extract-plugin
export default {"toggleSlider":"ToggleSlider_toggleSlider__9K+ks","slider":"ToggleSlider_slider__Rm6ew"};